// extracted by mini-css-extract-plugin
export default {"wrapper":"tD-z","button":"uD-z","alternate":"vD-z","disabled":"wD-z","paymentWarning":"xD-z","fadeIn":"yD-z"};